
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/auth/partnerships/stripe",
      function () {
        return require("private-next-pages/docs/auth/partnerships/stripe.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/auth/partnerships/stripe"])
      });
    }
  